import { AHIcon, AHSeparator } from "arkh";
import React from "react";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import {
  ListSectionHeader,
  ListSectionHeaderTitle,
} from "../../../components/atoms/ListSectionHeader";
import { UnitOption } from "../../RoutineAdmin/TaskScreenComponent/TaskResponseType/TaskNumberResponseOptions";
import { KPIUnit } from "../Edit/KPIEditParamList";

export function KPIUnitSelector({
  setUnit,
  unit,
}: {
  setUnit(_: KPIUnit): void;
  unit: KPIUnit;
}) {
  const intl_tokens = useIntlTokens();
  return (
    <>
      <ListSectionHeader>
        <ListSectionHeaderTitle>{intl_tokens.Unit}</ListSectionHeaderTitle>
      </ListSectionHeader>

      <UnitOption
        icon={<AHIcon type="currency" />}
        title={intl_tokens.Currency}
        isFirst
        onPress={() => {
          setUnit("CURRENCY");
        }}
        selected={unit === "CURRENCY"}
      />

      <AHSeparator />
      <UnitOption
        icon={<AHIcon type="other" />}
        title={intl_tokens.Other}
        isLast
        onPress={() => {
          setUnit("CUSTOM");
        }}
        selected={unit === "CUSTOM"}
      />
    </>
  );
}
